import React from 'react'

const SimpleProduct = ({ productInfo }) => {
    return (
        <>
            {/* <h2>Package Name</h2>
            <h3 class="serviceName">{productInfo?.product_name}</h3> */}
            <p>
                Based on your requirements, our{" "}
                <b class="serviceName">{productInfo?.product_name}</b>{" "}
                package is the ideal choice for you!{" "}
            </p>
        </>
    )
}

export default SimpleProduct